import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import U2000BasicDialog from "../../../../../u2000Core/components/dialog/U2000BasicDialog";
import type { U3141ChildLotChain } from "../../../../U3141Service";
import { NS } from "../../../../U3141";
import {
  U3141ChildLotChainDocumentsPanel,
  type U3141ChildLotChainDocumentsChangeDetail,
} from "../../u3141ChildLotChain/U3141ChildLotChainDocumentsPanel";

export interface U3141GraphChildLotDocumentsDialogProps {
  open: boolean;
  onClose: () => void;
  masterLotChainId: string;
  childLotChain: U3141ChildLotChain | null;
  onDocumentsChanged: (detail?: U3141ChildLotChainDocumentsChangeDetail) => void | Promise<void>;
}

export const U3141GraphChildLotDocumentsDialog: React.FC<U3141GraphChildLotDocumentsDialogProps> = ({
  open,
  onClose,
  masterLotChainId,
  childLotChain,
  onDocumentsChanged,
}) => {
  const { t } = useTranslation();
  const lotLabel = childLotChain?.lotDetail?.lot?.trim() ?? "—";
  const childLotChainId = childLotChain?.id ?? "";

  const handleDocumentsChange = useCallback(
    (detail?: U3141ChildLotChainDocumentsChangeDetail) => {
      void onDocumentsChanged(detail);
    },
    [onDocumentsChanged],
  );

  if (!childLotChainId) {
    return null;
  }

  return (
    <U2000BasicDialog
      isOpen={open}
      onClose={onClose}
      title={t("dlgGraphManageDocumentsTitle", { lot: lotLabel, ns: NS })}
      width="x-large"
      overlayClassName="z-110"
    >
      <U3141ChildLotChainDocumentsPanel
        key={childLotChainId}
        masterLotChainId={masterLotChainId}
        childLotChainId={childLotChainId}
        childLotChain={childLotChain}
        onDocumentsChange={handleDocumentsChange}
        nestedDialogOverlayClassName="z-120"
      />
    </U2000BasicDialog>
  );
};
